import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseMainCertifiedStateGuide.module.scss'

import SvgCertificationTitleInit from '@Ui/images/myhouse/myhouse_main_certification--titleInit.svg'
import SvgCertificationTitleRetry from '@Ui/images/myhouse/myhouse_main_certification--titleRetry.svg'
import SvgCertificationTitleClose from '@Ui/images/myhouse/myhouse_main_certification--close.svg'
import SvgCertificationTitleWarning from '@Ui/images/myhouse/myhouse_main_certification--warning.svg'
import useModal from '@Hooks/myhouse/useModal'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import useSetting from '@Hooks/myhouse/setting/useSetting'
import { TRADE } from '@Root/contants'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  houseNo?: any
  state?: any
  title?: any
  contents?: any
  grayTrailContents?: any
  contentsEmphasis?: any
  routeTitle?: any
  deleteTitle?: any
  modifyTitle?: any
  authApplyDate?: any
  myHouseAuthPossible?: any
  handleMyhouseAuthClick?: any
  handleStateGuideClose?: any
  noInsurance?: any
}

const MyhouseMainCertifiedStateGuide: React.FC<Props> = ({
  houseNo,
  state,
  title,
  contents,
  grayTrailContents,
  contentsEmphasis,
  routeTitle,
  deleteTitle,
  modifyTitle,
  authApplyDate,
  myHouseAuthPossible,
  handleMyhouseAuthClick,
  handleStateGuideClose,
  noInsurance,
}: Props) => {
  const { open } = useModal()
  const { setRemoveHouseNo } = useSetting()

  function handleRemoveClick(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault()
    handleNclick(NCLICK.MY_HOUSE.MAIN_INFO.AUTHENTICATION_GUIDE.EXPIRE_DATE_DELETE, e)
    setRemoveHouseNo(houseNo)
    open(MODAL_TYPE.DELETE_MYHOUSE, {
      nclickConfirm: NCLICK.MY_HOUSE.SETTING.POPUP.DELETE,
    })
  }

  return (
    <>
      {
        <>
          <div className={cx('article', state === 'TRADE_EXPIRED' && 'type_warning')}>
            <strong className={cx('title')}>
              {state === 'FAIL' && <SvgCertificationTitleRetry />}
              {state === 'TRADE_EXPIRED' && <SvgCertificationTitleWarning />}
              {state !== 'FAIL' && state !== 'TRADE_EXPIRED' && <SvgCertificationTitleInit />}
              {title}
            </strong>
            <p className={cx('text', state === 'FAIL' ? 'type_failed' : '', state === 'INIT' ? 'type_basic' : '', state === 'RETRY' || 'ING' ? 'type_standard' : '')}>
              {/* [D] contentsEmphasis 가 없으면 em태그 자체가 노출되지 않아야 합니다 */}
              {contentsEmphasis && <em className={cx('emphasis')}>{contentsEmphasis}</em>}
              {contents} <span className={cx('subtext')}>{grayTrailContents}</span>
              {state === 'FAIL' && !myHouseAuthPossible && (
                <>
                  <br />
                  해당 우리집은 더 이상 인증을 진행할 수 없습니다.
                </>
              )}
              {state === 'FAIL' && noInsurance && (
                <>
                  <br />
                  인증에 실패하면 무료 화재보험이 제공되지 않습니다.
                </>
              )}
            </p>
            {(state === 'FAIL' || state === 'ING') && authApplyDate && (
              <div className={cx('date')}>
                <dl className={cx('description')}>
                  <dt className={cx('description_title')}>신청일자 :</dt>
                  <dd className={cx('description_data')}>{authApplyDate}.</dd>
                </dl>
              </div>
            )}

            {routeTitle && myHouseAuthPossible && (
              <a href="#" className={cx('link_certify', 'type_more')} onClick={handleMyhouseAuthClick}>
                {routeTitle}
              </a>
            )}

            {state === 'TRADE_EXPIRED' && (
              <a href="#" className={cx('link_certify', 'type_warning')} onClick={handleRemoveClick}>
                {deleteTitle}
              </a>
            )}

            {state === 'TRADE_EXPIRED' && (
              <a
                href={`${process.env.REACT_APP_LAND_WEB_URL}/myhouse/register/main/${houseNo}`}
                className={cx('link_certify', 'type_warning')}
                onClick={handleNclickMix(NCLICK.MY_HOUSE.MAIN_INFO.AUTHENTICATION_GUIDE.EXPIRE_DATE_MODIFY)}
              >
                {modifyTitle}
              </a>
            )}

            {(state === 'RETRY' || state === 'FAIL') && (
              <button className={cx('button_close')} aria-label="닫기" type="button" onClick={(e) => handleStateGuideClose(e, houseNo, state)}>
                <SvgCertificationTitleClose />
              </button>
            )}
          </div>
        </>
      }
    </>
  )
}

export default MyhouseMainCertifiedStateGuide
